import React from 'react';
import { cnRadioButton } from '../RadioButton';
import './RadioButton-Control.css';
export var RadioButtonControl = function (_a) {
    var className = _a.className, controlRef = _a.controlRef, value = _a.value, name = _a.name, id = _a.id, checked = _a.checked, disabled = _a.disabled, onClick = _a.onClick, onChange = _a.onChange;
    return (React.createElement("input", { name: name, id: id, checked: checked, disabled: disabled, value: value, onClick: onClick, onChange: onChange, type: "radio", autoComplete: "off", className: cnRadioButton('Control', null, [className]), ref: controlRef }));
};
